const BYOB_CONSTANTS = {
  ADD_PRODUCT: 'ADD_PRODUCT',
  REMOVE_PRODUCT: 'REMOVE_PRODUCT',
  FETCH_BUNDLE_PRODUCT_DETAIL: 'FETCH_BUNDLE_PRODUCT_DETAIL',
  SET_BUNDLE_PRODUCT_DETAIL: 'SET_BUNDLE_PRODUCT_DETAIL',
  ON_ADD_PRODUCT: 'ON_ADD_PRODUCT',
  SET_BYOB_PRODUCT_DETAILS: 'SET_BYOB_PRODUCT_DETAILS',
  SET_REQUIRED_CAT: 'SET_REQUIRED_CAT',
  SET_CAT: 'SET_CAT',
  INIT_BUNDLE_CATEGORIES: 'INIT_BUNDLE_CATEGORIES',
  ADD_OPTIONAL_PRODUCT: 'ADD_OPTIONAL_PRODUCT',
  REMOVE_PRODUCT_DETAIL: 'REMOVE_PRODUCT_DETAIL',
  ADD_TO_BAG: 'ADD_TO_BAG',
  RESET_STATE: 'RESET_STATE',
  SET_ADD_TO_BAG_ERROR: 'SET_ADD_TO_BAG_ERROR',
};

export default BYOB_CONSTANTS;
